if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      //this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = $(".product-form__submit.button");        
      submitButton.attr('disabled', true);
      submitButton.addClass('loading');

      /******************Adding Multiple Products to cart ******************/
      var form = $(this.form);

      // $.ajax({
      //   type: "POST",
      //   url: "/cart/add.js",
      //   data: $(form).serialize(),
      //   success: () => {
      //     submitButton.removeClass('loading');
      //     submitButton.removeAttr('disabled');
      //     //window.location = '/checkout';
      //   },
      //   error: function(xhr, status, error) {
      //     console.log(xhr);
      //     submitButton.removeClass('loading');
      //     submitButton.removeAttr('disabled');
      //   },
      //   dataType: "json",
      // });

      var items=[
        // {
        //   id: $('#variant-input-hidden').val(),
        //   quantity: $('.quantity__input').val(),
        //   properties:{
        //     "paid_offer":$('#paid_offer').val(),
        //   }
        // }
      ];

      var currItems=[];

      $.ajax({
        url: "/cart.js"
      }).done(function(data) {
          JSON.parse(data).items.forEach((itm) => {
            if(itm.properties['paid_offer_free']=="free_product"){
            // console.log("999999999999999999999999999999999"+JSON.stringify(itm))
              currItems.push(""+itm.id);
            }
          });

          $('input[value="free_product"]').each(function(){
            var item= {id:$(this).attr('data-id'),quantity:1,properties:{
            "paid_offer_free":$(this).val(),
            "free_product_handle":$(this).attr('data-handle'),
          }}
          for(var id of currItems){
            console.log("///////////////////////"+id)
          }
          
          if(currItems.includes($(this).attr('data-id'))){
                console.log("ppppppppppppppppppppppp");                  
                submitButton.removeClass('loading');
                submitButton.removeAttr('disabled');
                window.location.href = "/checkout";
              }else{
                  console.log("uuuuuuuuuuuuuuuuu");
                  items.push(item);
              }
          })

        if(items.length>0){
          CartJS.addItems(items,{
            "success": function(data, textStatus, jqXHR) {
              submitButton.removeClass('loading');
              submitButton.removeAttr('disabled');
              setTimeout(function(e){
                submitButton.removeClass('loading');
                submitButton.removeAttr('disabled');
              },1000);
              window.location.href = "/checkout";
            }
          });
        }
      });
      /******************Adding Multiple Products to cart ******************/
    }
  });
}
